<template>
    <div>
        <template v-if="products">
            <v-client-table id="products-assigned-table" ref="assignedProductTable" :columns="columns" :options="options" :data="products">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">

                    <button type="button" class="btn btn-sm btn-default" v-on:click="show_export = !show_export">
                        <i class="fa fa-file-alt"></i> Export
                    </button>

                    <router-link :to="`/contracts/create?seller_type=${sellerType}&seller_id=${sellerId}`" class="btn btn-sm btn-default" title="Assign Product(s)">
                        <i class="fa fa-plus-circle"></i> Assign
                    </router-link>
                </div>

                <template slot="id_OLD" slot-scope="props">

                </template>

                <template slot="id" slot-scope="props">
                    <button type="button" class="btn btn-xs btn-default" title="View Hierarchy" v-on:click="getHierarchy(props.index)" v-if="false"><i class="fas fa-sm fa-sitemap"></i></button>
                    <router-link :to="`/contracts/view/${props.row.id}`" class="btn btn-xs btn-default" title="View Contract"><i class="fas fa-sm fa-eye"></i></router-link>
                    <router-link :to="`/contracts/edit/${props.row.id}`" class="btn btn-xs btn-default" title="Edit"><i class="fas fa-sm fa-edit"></i></router-link>
                    <router-link :to="`/contracts/delete/${props.row.id}`" class="btn btn-xs btn-default" title="Delete"><i class="fas fa-sm fa-trash text-danger"></i></router-link>
                </template>

                <template slot="product_name" slot-scope="props">
                    <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract" :class="{'text-muted': (props.row.display_as_inactive === 1)}">{{ props.row.product_name }}</router-link>
                </template>

                <template slot="product_level_name" slot-scope="props">
                    <span :class="{'text-muted': (props.row.display_as_inactive === 1)}">{{ props.row.product_level_name }}</span>
                </template>

                <template slot="manager_name" slot-scope="props">
                    <template v-if="props.row.current_manager_name">
                        <router-link :to="`/agents/view/${props.row.current_manager_id}`" title="View Agent Manager" v-if="props.row.current_manager_type === 'Agent'" :class="{'text-muted': (props.row.display_as_inactive === 1)}">
                            {{ props.row.current_manager_name }}
                        </router-link>
                        <router-link :to="`/agencies/view/${props.row.current_manager_id}`" title="View Agency Manager" v-else-if="props.row.current_manager_type === 'Agency'" :class="{'text-muted': (props.row.display_as_inactive === 1)}">
                            {{ props.row.current_manager_name }}
                        </router-link>
                    </template>
                    <template v-else>
                        <router-link :to="`/agents/view/${props.row.manager_id}`" title="View Agent Manager" v-if="props.row.manager_type === 'Agent'" :class="{'text-muted': (props.row.display_as_inactive === 1)}">
                            {{ props.row.manager_name }}
                        </router-link>
                        <router-link :to="`/agencies/view/${props.row.manager_id}`" title="View Agency Manager" v-else-if="props.row.manager_type === 'Agency'" :class="{'text-muted': (props.row.display_as_inactive === 1)}">
                            {{ props.row.manager_name }}
                        </router-link>
                    </template>
                </template>

                <template slot="writing_nbr" slot-scope="props">
                    <label v-if="props.row.is_writing_nbr_sent == 1" class="badge badge-warning" :class="{'text-muted': (props.row.display_as_inactive === 1)}">Writing# Sent</label>
                    <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract" :class="{'text-muted': (props.row.display_as_inactive === 1)}">{{ props.row.writing_nbr }}</router-link>
                </template>

                <template slot="date_of_change" slot-scope="props">
                    {{ props.row.date_of_change | moment("MM/DD/YYYY") }}
                </template>

                <template slot="termination_date" slot-scope="props">
                    <span v-if="props.row.termination_date">{{ props.row.termination_date | moment("MM/DD/YYYY") }}</span>
                </template>

                <template slot="contract_status_name" slot-scope="props">
                    <label :class="'badge badge-'+props.row.contract_status_color">{{ props.row.contract_status_name }}</label>
                </template>
            </v-client-table>
        </template>
        <template v-else>
            <v-server-table ref="productTable" url="/products" :columns="columns" :options="options">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">
                    <button class="btn btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                        <i class="fas fa-ban"></i>
                    </button>
                    <button class="btn btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                        <i class="fas fa-filter"></i>
                        <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                    </button>
                    <button class="btn btn-warning" v-on:click="sendToPrint()" title="Printable Friendly List">
                        <i class="fas fa-print"></i>
                    </button>
                    <button class="btn btn-success" v-on:click="exportList()" title="Export Parts List">
                        <i class="fas fa-file-excel"></i>
                    </button>
                </div>

                <template slot="id" slot-scope="props">
                    <router-link :to="`/products/${props.row.id}`" class="btn btn-xs btn-secondary" title="View Part">View</router-link>
                </template>

                <template slot="product_name" slot-scope="props">
                    <router-link :to="`/products/${props.row.id}`" title="View Part">{{ props.row.product_name }}</router-link>
                </template>

                <template slot="commission" slot-scope="props">
                    <span v-if="props.row.product_level_commission">{{ props.row.product_level_commission }}</span>
                    <span v-else>{{ props.row.commission }}</span>
                </template>

                <template slot="customer_name" slot-scope="props" v-if="!customerId">
                    <router-link :to="`/customers/${props.row.customer_id}`" title="View Customer">{{ props.row.customer_name }}</router-link>
                </template>

                <template slot="date_of_change" slot-scope="props">
                    {{ props.row.date_of_change | moment("MM/DD/YYYY") }}
                </template>

                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                </template>
            </v-server-table>
        </template>

        <b-modal v-model="show_export" :title="'Export Assigned Products'" size="lg" no-fade :ok-title="exportTitle" :ok-disabled="sending" @ok="exportProducts">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Export Type:</div>
                <div class="col-md-7 col-12">
                    <b-form-radio-group v-model="send_export_type" name="export_type" plain>
                        <b-form-radio value="xlsx">
                            <i class="fa fa-file-excel"></i> XLSX
                        </b-form-radio>
                        <b-form-radio value="pdf">
                            <i class="fa fa-file-pdf"></i> PDF
                        </b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Include Inactive:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="send_include_inactive" :value="true" :unchecked-value="false" plain />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Include Manager:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="send_include_manager" :value="true" :unchecked-value="false" plain />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Separate Legacy Commission:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="send_include_legacy_commission" :value="true" :unchecked-value="false" plain>
                        <i class="fa fa-question-circle" title="If Checked, AMOS will included the legacy 'Commission' field and keep that value separate from the new 'Level' field. If not check, the 'Level' field will display the assigned level and fallback to displaying the legacy commission value."></i>
                    </b-form-checkbox>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Email Export:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="send_email" :value="true" :unchecked-value="false" plain />
                </div>
            </div>

            <div class="row mb-3" v-if="send_email">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right" :class="{'text-muted': !errors.email, 'text-danger': errors.email}">Email:</div>
                <div class="col-md-7 col-12">
                    <b-form-input type="email" v-model="email_recipient" size="sm" placeholder="Enter Recipient Email" :class="{'is-invalid': errors.email}" />

                    <div class="text-danger mt-2" v-if="errors.email">
                        <ul class="list-unstyled mb-0">
                            <li v-for="err in errors.email">{{ err }}</li>
                        </ul>
                    </div>

                    <div class="mt-1" v-if="emails.length > 0">
                        <span class="text-muted">Suggested Recipients:</span>
                        <ul class="list-unstyled">
                            <li v-for="email in emails">
                                <a href="javascript:void(0)" v-on:click="email_recipient = email.email">{{ email.email }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            products: {
                type: Array,
                default: null,
            },

            sellerId: {
                type: Number,
                default: null
            },

            sellerType: {
                type: String,
                default: null
            },

            emails: {
                type: Array,
                default: () => []
            },
        },

        data() {
            return {
                show_export: false,
                send_email: false,
                send_export_type: 'xlsx',
                send_include_inactive: false,
                send_include_manager: false,
                send_include_legacy_commission: false,
                email_recipient: null,
                sending: false,
                columns: [
                    'id',
                    'product_name',
                    'product_level_name',
                    //'commission',
                    'manager_name',
                    'writing_nbr',
                    'date_of_change',
                    'termination_date',
                    'contract_status_name'
                ],
                options: {
                    skin: "table table-bordered table-sm table-hover",
                    headings: {
                        id: 'Actions',
                        product_name: 'Product',
                        product_level_name: 'Level',
                        date_of_change: 'Date of Change',
                        commission: 'Commission',
                        manager_name: 'Manager',
                        writing_nbr: 'Writing#',
                        termination_date: 'Termination',
                        contract_status_name: 'Status',
                    },
                    texts:{
                        filterPlaceholder:"Search Assigned Products",
                    },
                    orderBy: {
                        ascending: true,
                        column: 'product_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('productAssignedCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                    //showChildRowToggler: false,
                    childRow: 'hierarchy-table-row',
                },

                filters: {
                    'products.customer_id': [],
                    'products.deleted_at': null,
                },

                errors: {},
            }
        },

        computed: {

            filterData(){
                //Send it
                return this.$store.state.productFilters ? this.$store.state.productFilters : {};
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },

            exportTitle(){
                //Check for sending
                if(this.send_email)
                {
                    return 'Email '+this.send_export_type.toUpperCase()+' Export';
                }

                return 'Generate '+this.send_export_type.toUpperCase()+' Export';
            },
        },

        methods: {
            getFilters(){
                //Check the store for the filters
                if(this.$store.state.productFilters)
                {
                    //Stop here
                    return;
                }

                //Send it
                this.$http.get('/products/resources')
                    .then(response => {
                        //Commmit
                        this.$store.commit('productFilters', response.data);
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.productTable.refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs.productTable.refresh();
            },

            exportList(){
                //Send to a NEW print version
                var url = '/products/export?';

                //Build it
                if(this.mfg_location_id)
                {
                    url += 'mfg_location_id=' + this.mfg_location_id + '&';
                }
                //Build it
                else if(this.mfgId)
                {
                    url += 'mfg_location_id=' + this.mfgId + '&';
                }

                //Loop and build ALL
                var keys = Object.keys(this.filters);

                //Loop it
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Append
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        //Make sure it's not empty
                        if(this.filters[keys[i]].length > 0)
                        {
                            //Build it
                        }
                    }
                    else if(this.filters[keys[i]])
                    {
                        //Append
                        url += keys[i] + '=' + this.filters[keys[i]] + '&';
                    }
                }

                //Send to the path
                window.open(url);
            },

            getHierarchy(index){
                this.$refs.assignedProductTable.toggleChildRow(index);
            },

            sendToUrl(url){
                //Send it
                window.open(url);
            },

            exportProducts(bvModalEvent){
                // Prevent modal from closing
                bvModalEvent.preventDefault()

                //Loading?
                this.sending = true;
                this.errors = {};

                //SEtup
                var payload = {
                    send_email: this.send_email,
                    email: this.email_recipient,
                    export_type: this.send_export_type,
                    include_inactive: this.send_include_inactive,
                    include_manager: this.send_include_manager,
                    include_legacy_commission: this.send_include_legacy_commission
                };

                //Send it
                this.$http.getWeb('/contracts/export/seller/'+this.sellerType+'/'+this.sellerId, payload)
                    .then(response => {
                        //Alert the User
                        this.$toastr.s(response.data.msg);

                        //Close the MOdal
                        this.show_export = false;

                        //Reset the Form
                        this.send_email = false;
                        this.email_recipient = null;
                        this.send_export_type = 'xlsx';
                        this.send_include_inactive = false;
                        this.send_include_manager = false;
                        this.send_include_legacy_commission = false;

                        //Check for a URL
                        if(response.data.url)
                        {
                            window.open(response.data.url);
                        }
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Save Agent');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.sending = false;
                    });
            },
        },

        mounted() {
            //Get the filtes
            //this.getFilters();
        }
    }
</script>